import { ProctorManagementNavigationTabs } from '@exam-center/proctor-management';
import { Box, Flex, PageHeader } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function ProctorsLayout() {
  return (
    <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
      <PageHeader title='จัดการผู้คุมสอบ' tabs={<ProctorManagementNavigationTabs />} />
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <Outlet />
      </Box>
    </Flex>
  );
}
